import { i18n } from 'i18n';

export const CURRENCIES = () => ({
	EUR: i18n.t('Евро'),
	USD: i18n.t('Доллар США'),
	RUB: i18n.t('Российский рубль'),
});
